import { ApolloProvider } from "@apollo/client";
import { FC } from "react";
import { Outlet } from "react-router-dom";
import "./public-layout.scss";
import { Header } from "@components/header";
import { useGQLClient } from "@utils/graphql.util";
import { useFavicon } from "@hooks/use-favicon";

const PublicLayout: FC = () => {
  const client = useGQLClient();
  useFavicon("./logo.png");
  return (
    <main className="template">
      <div className="content-area w-100">
        <ApolloProvider client={client}>
          <div className="header-area">
            <Header basePath="/auth/signin" />
          </div>
          <Outlet />
        </ApolloProvider>
      </div>
    </main>
  );
};

export default PublicLayout;
